import { AxiosError } from 'axios';
import { t } from 'i18next';

const isTechnical = (message: string): boolean =>
    /\b(exception|inner exception|stack trace|constraint|npgsql|sqlstate|\d{5}: )/i.test(message);

const byStatus = (status?: number): string => {
    if (status === 401) return t('general.erroNaoAutenticado');
    if (status === 403) return t('general.erroSemPermissao');
    if (status === 404) return t('general.erroNaoEncontrado');
    if (status && status >= 500) return t('general.erroServidor');
    return t('general.erroInesperado');
};

// O ErrorApiResponse devolve { key, message }; tratar como string vira "[object Object]".
type DomainError = string | { key?: string; message?: string };

const readDomainMessage = (errors?: DomainError[]): string | undefined => {
    const first = errors?.[0];

    if (typeof first === 'string') return first;

    return first?.message;
};

export const apiErrorMessage = (err: unknown): string => {
    const axiosError = err as AxiosError<{ errors?: DomainError[]; message?: string }>;
    const status = axiosError?.response?.status;
    const data = axiosError?.response?.data;

    const domainMessage = readDomainMessage(data?.errors);
    if (domainMessage) return domainMessage;

    const backendMessage = data?.message;
    if (backendMessage && !isTechnical(backendMessage)) return backendMessage;

    return byStatus(status);
};
